var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okText: this.$store.getters.language["common.okButton"],
        "ok-disabled": _vm.disableSubmit || _vm.islock,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c("sys-certificate-form", {
        ref: "realForm",
        attrs: {
          disabled: _vm.disableSubmit,
          islock: _vm.islock,
          systemlist: _vm.systemlist
        },
        on: { ok: _vm.submitCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }